module.exports = {"TXTWCL_Suggested_amounts":{"id":"TXTWCL_Suggested_amounts","defaultMessage":"Javasolt összeg","track":"Suggested amounts"}}